import React from 'react';
import { Link } from 'react-router-dom';
import allProjects from '../data/projects';

const projects = allProjects.filter((p) => p.featured);

function Projects() {
  return (
    <div>

      {/* Section header - full width */}
      <div className="flex flex-row items-center pb-6">
        <div className="flex-grow-0 font-sans text-slate-400 font-medium pr-4 md:text-xl text-lg">
          What I've Built
        </div>
        <div className="flex-grow h-[1px] bg-slate-700"></div>
      </div>

      {/* Cards - centered */}
      <div className="flex flex-col items-center">
        <div className="w-full md:w-3/4">
          {projects.map((project) => (
            <div className="py-2" key={project.slug}>
              <Link to={`/projects/${project.slug}`} className="group">
                <div className="
                  p-3 bg-slate-900
                  hover:-translate-y-[4px] transition-transform duration-300 ease-out
                  border border-transparent hover:border-teal-400 group-focus-visible:border-teal-400
                  shadow-[3px_3px_8px_rgba(20,184,166,0.2)]
                  hover:shadow-[5px_5px_12px_rgba(20,184,166,0.35)] group-focus-visible:shadow-[5px_5px_12px_rgba(20,184,166,0.35)]
                ">
                  <div className="py-1 font-sans text-teal-300 font-medium md:text-xl text-lg">
                    {project.title}
                  </div>
                  <div className="py-1 font-sans text-slate-400 text-sm leading-relaxed">
                    {project.description}
                  </div>
                  {project.tech?.length > 0 && (
                    <div className="flex flex-wrap gap-2 pt-2">
                      {project.tech.map((t) => (
                        <span key={t} className="text-xs font-mono text-slate-400 border border-slate-700 px-2 py-0.5 rounded-full">
                          {t}
                        </span>
                      ))}
                    </div>
                  )}
                </div>
              </Link>
            </div>
          ))}
          <div className="pt-4">
            <Link
              to="/projects"
              className="font-mono text-sm text-slate-500 hover:text-teal-300 transition-colors duration-200"
            >
              → All projects
            </Link>
          </div>
        </div>
      </div>

    </div>
  );
}

export default Projects;